import { OnlyViewHoc } from 'hocs'
import * as React from 'react'

import { getFio } from 'helpers/formatText'
import { SwapSupervisorsDTO } from 'services/api/SupervisorsApi'

import { AppButton } from 'components/AppButton'
import { AppModalHeader } from 'components/AppModal/AppModalHeader'
import { AppSelect } from 'components/AppSelect'

import { ISupervisor } from 'models/supervisor'

import styles from './SupervisorDetails.module.scss'

interface Props {
  supervisor: ISupervisor
  supervisors: ISupervisor[]
  disabled: boolean
  onClose?(): void
  onSwap: (data: SwapSupervisorsDTO) => void
}

export const SupervisorDetails: React.FC<Props> = ({
  supervisor,
  supervisors,
  disabled,
  onClose,
  onSwap,
}) => {
  const [selectedSupervisorPhone, setSelectedSupervisorPhone] =
    React.useState('')

  const supervisorsOptions = supervisors.map(item => ({
    title: getFio(item),
    value: item.phone,
  }))

  const _onSwap = () => {
    onSwap({
      old_supervisor: supervisor.phone,
      new_supervisor: selectedSupervisorPhone,
    })
  }

  return (
    <OnlyViewHoc>
      <div className={styles.container}>
        <AppModalHeader
          onClose={onClose}
          title={`
          ${getFio(supervisor)}
          \n
          ${supervisor.phone}
        `}
        />
        <div className={styles.content}>
          <AppSelect
            text={
              supervisorsOptions.find(
                item => item.value === selectedSupervisorPhone,
              )?.title
            }
            onChangeValues={([value = '']) => setSelectedSupervisorPhone(value)}
            list={supervisorsOptions}
          />

          <AppButton
            disabled={!selectedSupervisorPhone || disabled}
            onClick={_onSwap}
            size="small"
            variant="siren"
          >
            Сохранить
          </AppButton>
        </div>
      </div>
    </OnlyViewHoc>
  )
}
